<template>
  <div class="text-center">
    <div class="bg-gray-200 p-8 text-sm text-gray-900 inline-block mt-20 rounded">
      <span class="blink">Validating your access...</span>
    </div>
  </div>
</template>

<script>
  export default {
    created() {

      // we also need to consider a case when a broker is testing out
      // the email link for the client. In that case we will need to
      // log the current user out
      let t = localStorage.getItem("bp-broker-jwt")
      if(t != null) {
        localStorage.removeItem('bp-broker-jwt')
        this.$store.commit('setIsLoggedIn', false)
      }

      // handle the landing for the client
      if(this.$route.params.key != null) {
        this.apiPost({
          key : this.$route.params.key
        }, 'client/validate-key', (data) => {

          if(data.error != null) {
            this.$router.push({
              name  : 'client-link-error',
              params: {
                type : data.error
              }
            })
          }

          else {

            this.$store.commit("setView", "client")
            this.broker = data.broker
            localStorage.setItem("bp-broker-jwt", data.token)
            this.$store.commit('setIsLoggedIn', true)
            this.$store.commit('setUser', data.user)
            this.$store.commit("clientModule/setBroker", data.broker)
            this.$router.push({
              name  : 'client-home',
              params: {
                clientId: data.client.id
              }
            })
          }
        })
      }
    }
  }
</script>
